import { DecoratorNode } from "lexical";
// FUTURE: suportar metadados (tipo, formato, tooltip), ícone, filtros aplicados visualmente e estado inválido.

export class VariableNode extends DecoratorNode<object> {
  __variableName: string;

  static getType() {
    return "variable";
  }

  static clone(node: VariableNode) {
    return new VariableNode(node.__variableName, node.__key);
  }

  constructor(variableName: string, key?: string) {
    super(key);
    this.__variableName = variableName;
  }

  createDOM() {
    const span = document.createElement("span");
    span.className =
      "variable-placeholder bg-yellow-100 text-yellow-800 font-bold rounded px-1 mx-0.5 cursor-pointer";
    span.contentEditable = "false";
    span.setAttribute("data-variable", this.__variableName);
    span.textContent = `{{${this.__variableName}}}`;
    return span;
  }

  updateDOM() {
    return false;
  }

  exportJSON() {
    return {
      type: "variable",
      version: 1,
      variableName: this.__variableName,
    };
  }

  getVariableName() {
    return this.__variableName;
  }
}